import EntryPoint from 'Engine/EntryPoint';
import eSymbolIndex from '../symbols/eSymbolIndex';

export default new class XXXDataParser {
    constructor() {
        this.extraSymbolsRelation = {
            9: 1,
            10: 2,
            11: 3
        }
    }
    parseInit(data) {
        let newData = {};
        newData.action = 'init';
        newData.balance = data.balance;
        newData.params = {
            betPossible: data.available_bets
        };
        newData.current = {
            bet: data.bet_amount,
            lines: 5
        };

        newData.currencyInfo = {
            decimals: data.decimals,
            symbol: data.currency,
            currency: data.currency
        };

        newData.freespinsData = this._makeFreespinsData(data);
        newData.jackpot = data.jackpot;

        newData.paytableInfo = data.paytable;

        newData.jackpotCoeffs = data.jackpots_coeffs;

        newData.progresesToJackpot = data.jack_potter_progress;

        newData.freebets = data.freebets;

        return newData;
    }

    parseSpin(data) {
        let newData = {};
        newData.action = 'spin';
        newData.balance = data.balance;
        newData.spin = {
            reels: data.spin?.reels || data.bonus.reels,
            winnings: this.makeWinnings(data),
            extraReels: data.chili.reels.map(symbolIndex => [this.extraSymbolsRelation[symbolIndex]]),
            extraCoef: data.chili.coef,
            bet: data.bet_amount,
        };
        newData.freespinsData = this._makeFreespinsData(data);
        newData.jackpotCoeffs = data.jackpots_coeffs;
        newData.jackpot = data.jackpot;

        newData.freebets = data.freebets;

        return newData;
    }

    makeWinnings( data) {
        const spinData = data.spin;
        let winnings = {};
        if (spinData) {
            winnings.lines = spinData.win_lines
            winnings.totalWin = spinData.win_amount * data.chili.coef;
            winnings.lines.forEach(winLineData => winLineData.isScatter = winLineData.icon === eSymbolIndex.ESI_SCATTER)
        }
        return winnings;
    }

    _makeFreespinsData(data) {
        if (!data.freespins) {
            return null;
        }
        return {
            totalWin: data.freespins.freespins_total_win,
            freespins: data.freespins.freespins_count,
            freespinsTriggered: data.freespins.freespins_triggered,
            isFreespinsGame: data.freespins.is_freespins,
            availableReels: data.freespins.available_reels,
        };
    }
}
